import { Component, OnDestroy, OnInit, ViewChild, HostListener } from '@angular/core';
import { AsistenciaService } from '../_services/asistencia.service';
import { ActivatedRoute, Router, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs';
import { CustomAlertService } from '../../../_components/custom-alert/custom-alert.service';
import { NavBarObject } from '../../../_components/nav-bar/config';
import { EstudioService } from '../../estudio/estudio.service';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Persona } from '../../../_models/persona';
import { DynamicBarService } from '../../../_components/dynamic-bar/dynamic-bar.service';
import { Title } from '@angular/platform-browser';
import * as d3 from 'd3';
import { FormControl } from '@angular/forms';
import { MatDrawer } from '@angular/material/sidenav';

@Component({
  selector: 'asistencia-reporte-director-curso',
  standalone: false,
  templateUrl: 'reporte-director-curso.component.html',
  styleUrls: [
    './reporte-director-curso.component.scss',
    '../../nivelaciones/citacion-materia-curso/citacion-materia-curso.component.scss'
  ]
})
export class AsistenciaReporteDirectorCursoComponent implements OnInit, OnDestroy {
  periodosNavBar;

  cursoID: number;
  periodoID = 0;
  displayedColumns = ['Alumno'];
  materias: any[] = [];
  tiposAsistencia;
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  viewMode: 'percentage' | 'numbers' = 'percentage';

  acumuladoSub: Subscription;
  periodosSub: Subscription;
  paramSub: Subscription;
  cursoSub: Subscription;

  // NEW: sub para eventos de router (cerrar drawer en modo over)
  private routerEventsSub?: Subscription;

  selectedSection = 1;

  // ===== Drawer (sin observables para breakpoints) =====
  @ViewChild('drawer', { static: false }) drawer: MatDrawer;
  drawerMode: 'side' | 'over' = 'side';
  drawerOpened = true;

  // NEW: guardamos la estrategia original del router para restaurarla
  private _origShouldReuse: (future: any, curr: any) => boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private asistenciaService: AsistenciaService,
    private customAlertService: CustomAlertService,
    private estudioService: EstudioService,
    private dynamicBarService: DynamicBarService,
    private titleService: Title
  ) {
    // Guarda la estrategia actual por si otra parte de la app la cambió
    this._origShouldReuse = this.router.routeReuseStrategy.shouldReuseRoute.bind(this.router.routeReuseStrategy);
  }

  ngOnInit() {
    // ====== Drawer: modo inicial según viewport (sin RxJS) ======
    this.updateDrawerForViewport();

    // ====== Router Reuse: restablecer comportamiento por defecto (FIX del bloqueo de navegación) ======
    // Reutiliza solo cuando es la misma configuración de ruta (comportamiento estándar)
    this.router.routeReuseStrategy.shouldReuseRoute = (future, curr) =>
      future.routeConfig === curr?.routeConfig;

    // (Opcional útil) Cierra el drawer en modo 'over' al iniciar navegación, para no bloquear la vista
    this.routerEventsSub = this.router.events.subscribe(ev => {
      if (ev instanceof NavigationStart) {
        if (this.drawerMode === 'over' && this.drawer?.opened) {
          this.drawer.close();
        }
      }
    });

    // ====== Tu lógica original ======
    this.tiposAsistencia = this.route.parent.snapshot.data['tiposAsistencia'];
    this.cursoID = +this.route.snapshot.paramMap.get('cursoID');

    const qpView = this.route.snapshot.queryParamMap.get('viewMode') as 'percentage' | 'numbers' | null;
    this.viewMode = qpView ?? 'percentage';

    this.paramSub = this.route.params.subscribe(params => {
      this.periodoID = +params['periodoID'] || 0;
      this.dataSource = null;

      this.acumuladoSub = this.asistenciaService.getAcumuladoCurso(this.cursoID, this.periodoID).subscribe(res => {
        this.periodosNavBar = undefined;
        const data = this.asistenciaService.extractData(res);
        data.alumnos.map(alumnoI => {
          alumnoI.materias.map(materiaI => {
            if (!Object.prototype.hasOwnProperty.call(materiaI, 'detalle')) {
              materiaI['detalle'] = { show: false };
            }
          });
        });
        this.dataSource = new MatTableDataSource<any>(data.alumnos);
        this.materias = data.materiasEncabezado;
        this.displayedColumns = ['Alumno'];
        this.materias.map(el => this.displayedColumns.push(el.id.toString()));
        this.displayedColumns.push('end');

        this.periodosSub = this.estudioService.getPeriodos(true).subscribe(res1 => {
          const periodos = this.asistenciaService.extractData(res1);
          const periodo = periodos.find(periodoI => periodoI.id === data.periodo.id);
          if (+this.periodoID === 0 || this.periodoID == null) {
            this.periodoID = periodo.id;
          }
          if (this.periodosNavBar) {
            this.periodosNavBar = undefined;
          }
          this.periodosNavBar = [];
          periodos.map(periodoI => {
            this.periodosNavBar.push(
              new NavBarObject(
                periodoI.nombre,
                [`/asistencia/reporte/curso/${this.cursoID}/periodo/${periodoI.id}`],
                periodoI.id,
                [new NavBarObject('Acumulado', [`/asistencia/reporte/curso/${this.cursoID}/periodo/${periodoI.id}`], periodoI.id)].concat(
                  periodoI.periodos.map(child => {
                    if (child.tipo < 2) {
                      return new NavBarObject(
                        `Periodo ${child.nombre}`,
                        [`/asistencia/reporte/curso/${this.cursoID}/periodo/${child.id}`],
                        child.id
                      );
                    } else {
                      return false as any;
                    }
                  })
                )
              )
            );
          });
        });
        this.initDataSource();
      }, err => {
        this.customAlertService.setCustomMessage({
          tipo: 'error',
          texto: `Se ha presentado un error cargando los datos de la asistencia. Por favor recargue la página.<br> Código de error: ${err.statusText}`
        });
      });
    });

    this.cursoSub = this.estudioService.getCurso(this.cursoID).subscribe(res => {
      const curso = this.estudioService.extractData(res);
      this.dynamicBarService.setBarra('asistencia-director-curso-barra', { curso });
      this.titleService.setTitle(`Asistencia curso ${curso.nickName}`);
    });

    // ⚠️ IMPORTANTE: QUITAMOS esto (era la causa de bloqueo):
    // this.router.routeReuseStrategy.shouldReuseRoute = () => true;
  }

  ngOnDestroy() {
    if (this.acumuladoSub) this.acumuladoSub.unsubscribe();
    if (this.periodosSub) this.periodosSub.unsubscribe();
    if (this.paramSub) this.paramSub.unsubscribe();
    if (this.cursoSub) this.cursoSub.unsubscribe();
    if (this.routerEventsSub) this.routerEventsSub.unsubscribe();

    // Restaurar la estrategia original del router
    if (this._origShouldReuse) {
      this.router.routeReuseStrategy.shouldReuseRoute = this._origShouldReuse;
    }
  }

  // ===== Drawer helpers (sin observables para breakpoints) =====
  private updateDrawerForViewport(): void {
    const isSmall = window.matchMedia('(max-width: 992px)').matches;
    this.drawerMode = isSmall ? 'over' : 'side';
    this.drawerOpened = !isSmall;
  }

  @HostListener('window:resize')
  onResize() {
    const prevMode = this.drawerMode;
    this.updateDrawerForViewport();

    // Si cambió el modo puedes forzar apertura/cierre según prefieras:
    // if (this.drawerMode === 'side' && prevMode !== 'side') this.drawer?.open();
    // if (this.drawerMode === 'over' && prevMode !== 'over') this.drawer?.close();
  }

  // ===== Tabla / filtros =====
  initDataSource() {
    this.dataSource.sort = this.sort;
    this.dataSource.filterPredicate = (data, filter: string) => {
      const accumulator = (currentTerm, key) => {
        return key === 'alumno' ? currentTerm + data.nombresApellidos : currentTerm + data[key];
      };
      const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
      const transformedFilter = filter.trim().toLowerCase();
      return dataStr.indexOf(transformedFilter) !== -1;
    };
  }

  filtroTexto(filterValue: string) {
    filterValue = filterValue.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }

  changeViewMode(viewMode: 'percentage' | 'numbers') {
    this.viewMode = viewMode;
    this.router.navigate(['.'], { relativeTo: this.route, queryParams: { viewMode }, replaceUrl: true });
  }

  getDetailsAsistencia(alumno, materiaID, contenedor) {
    if (!d3.select(`.data-${alumno.id}-${materiaID}`).empty()) {
      d3.select(`.data-${alumno.id}-${materiaID}`).remove();
      return;
    }
    d3.select('.detail-container').remove();

    const tipDiv = d3
      .select(contenedor)
      .append('div')
      .attr('class', `detail-container mat-elevation-z24 data-${alumno.id}-${materiaID}`);
    tipDiv
      .append('div')
      .attr('class', 'flex-wrap')
      .html('<div class="inline-flex">Ausencias</div><div class="inline-flex">Retardos</div><div class="inline-flex">Total</div>');
    tipDiv.append('div').attr('class', 'loading').html('Cargando datos...');
    this.asistenciaService.getDetailAcumulada(alumno.id, materiaID, this.periodoID).subscribe(res => {
      tipDiv.select('.loading').remove();
      this.asistenciaService.setDetailAcumuladaHTML(this.asistenciaService.extractData(res), tipDiv);
    });
  }

  getDetailsTarea(alumno, materiaID, contenedor) {
    if (!d3.select(`.data-tarea-${alumno.id}`).empty()) {
      d3.select(`.data-tarea-${alumno.id}`).remove();
      return;
    }
    d3.select('.detail-container').remove();

    const detailDiv = d3
      .select(contenedor)
      .append('div')
      .attr('class', `detail-container mat-elevation-z24 data-tarea-${alumno.id}`);

    detailDiv.append('div').append('h5').text('Faltas de tareas');

    detailDiv.append('div').attr('class', 'loading').html('Cargando datos...');
    this.asistenciaService.getDetailTareasAcumuladas(alumno.id, materiaID).subscribe(res => {
      detailDiv.select('.loading').remove();
      this.asistenciaService.setTareasDetailHTML(this.asistenciaService.extractData(res)[0], detailDiv);
    }, err => {});
  }

  setSelectedSection() {
    d3.select('.detail-container').remove();
  }
}
